import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FilteringItem } from '../../../../interfaces/filters.interface';
import { SiteConfiguration } from '../../../../configuration/configuration';
import { ViewersService } from '../../../../services/viewers.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-filters',
  imports: [CommonModule],
  templateUrl: './filters.component.html',
  styleUrl: './filters.component.css'
})
export class FiltersComponent {
  @Input() filters!: FilteringItem[];
  @Output() closemenu: EventEmitter<void> = new EventEmitter<void>();
  public vipColor: string = SiteConfiguration.features.filters.ui.vip;
  public regularColor: string = SiteConfiguration.features.filters.ui.regular;

  constructor(
    private readonly viewersService: ViewersService
  ) { }

  public onFilter(filter: FilteringItem) {
    // If the filter is view360 mode, load the 3D view
    if (filter.mode === 'view360') {
      this.viewersService.load3dView(filter.mapid).subscribe();
    }
    // Close the menu after selecting a filter
    this.closemenu.emit();
  }

}
